import React, { Fragment } from 'react'

import styled from 'styled-components'

import { ResponsivePXValue } from '@components/Theme'
import { ContentCard, ContentCardHeaderEnum } from '@molecules/index'
import { UserCardList } from '@organisms/index'
import { SearchEngineOptimization } from '@utility/SearchEngineOptimization'

const seo = {
  name: 'User Dashboard',
  title: 'User Dashboard',
  meta: [{
    name: 'robots',
    content: 'noindex,nofollow',
  }],
}

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
 
  ${ResponsivePXValue('padding', { mobile: '0 16px', tablet: '0 20px', desktop: '0 24px' })};
`

export function Payment(): JSX.Element {

  const title = 'PAYMENT DETAILS'
  const description = 'Your Meal Kit plan is renewed every Wednesday at 9AM. If your billing details have changed you can update them below.'

  return (
    <Fragment>
      <SearchEngineOptimization seo={seo} />
      <ContentCard title={title} description={description} headerType={ContentCardHeaderEnum.STANDARD}>
        <ListContainer>
          <UserCardList />
        </ListContainer>
      </ContentCard>
    </Fragment>
  )

}
